
import About from "pages/About";
import Contact from "pages/Contact";
import Features from "pages/Features";
import Home from "pages/Home";
import Privacy from "pages/Privacy";
import TermsAndConditions from "pages/TermsAndConditions";
import Blog from "crm/other/Blog";
import { Routes, Route, Navigate } from "react-router-dom";
import Industries from "pages/Industries";
import DynamicPage from "pages/DynamicPage";


export default function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/features" element={<Features />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/blogs" element={<Blog />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/termsAndConditions" element={<TermsAndConditions />} />
            <Route path="/:slug" element={<DynamicPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

    );
}
